import { OrderType } from '@eih-netbroker/common';
import { number, object, string } from 'yup';
import { useOptions } from '../../../shared/services/useOptions';

import { useNormalOrderSchemaCommon } from '@eih-netbroker/common';
import { useMemo } from 'react';

export const useNormalOrderSchema = () => {
  const { getTradingSessionOptions } = useOptions();

  const p = useMemo(
    () => ({
      getTradingSessionOptions,
    }),
    [getTradingSessionOptions],
  );

  return useNormalOrderSchemaCommon(p);
};

export const simpleTradeOrderSchema = object().shape(
  {
    instrument: object().required(),
    orderType: string().required(),
    quantity: number().required().moreThan(0),
    price: number().when('orderType', orderType => {
      return orderType.includes(OrderType.Limit) || orderType.includes(OrderType.StopLimit)
        ? number().required().moreThan(0)
        : number().notRequired();
    }),
  },
  [['orderType', 'orderType']],
);
